module.exports = __webpack_public_path__ + "img/jellybean_trailblazer.62cf4889.png";